export default function RequestItemForm({
  values,
  errors,
  offer,
  trip,
  cashEstimate,
  onFieldChange,
  onSubmit,
}) {
  function fieldError(field) {
    if (!errors[field]) return null;
    return (
      <span
        className="field-error"
        id={`request-${field}-error`}
        role="alert"
      >
        {errors[field]}
      </span>
    );
  }

  function update(field, event) {
    onFieldChange(field, event.target.value);
  }

  return (
    <form className="form" noValidate onSubmit={onSubmit}>
      <p>
        {offer ? (
          <>
            Local run: {offer.store_name} | {offer.public_area}
            <br />
            Runner fee: PHP{" "}
            {Number(offer.runner_fee).toLocaleString("en-PH", {
              minimumFractionDigits: 2,
            })}
          </>
        ) : (
          <>
            {trip?.origin} to {trip?.destination} | Trip fee: PHP{" "}
            {Number(trip?.service_fee || 0).toLocaleString("en-PH", {
              minimumFractionDigits: 2,
            })}
          </>
        )}
      </p>
      <label>
        Item
        <input
          name="item"
          required
          maxLength="200"
          aria-invalid={Boolean(errors.item)}
          aria-describedby={errors.item ? "request-item-error" : undefined}
          value={values.item}
          onChange={(event) => update("item", event)}
        />
        {fieldError("item")}
      </label>
      <label>
        Item budget (PHP)
        <input
          name="budget"
          type="number"
          min="0.01"
          step="0.01"
          required
          aria-invalid={Boolean(errors.budget)}
          aria-describedby={errors.budget ? "request-budget-error" : undefined}
          value={values.budget}
          onChange={(event) => update("budget", event)}
        />
        {fieldError("budget")}
      </label>
      <label>
        Delivery city/area
        <input
          name="city"
          required
          aria-invalid={Boolean(errors.city)}
          aria-describedby={errors.city ? "request-city-error" : undefined}
          value={values.city}
          onChange={(event) => update("city", event)}
        />
        {fieldError("city")}
      </label>
      {cashEstimate !== null && (
        <p className="cash-estimate">
          Estimated cash due: PHP{" "}
          {cashEstimate.toLocaleString("en-PH", {
            minimumFractionDigits: 2,
          })}{" "}
          (item budget + runner fee). No in-app payment.
        </p>
      )}
      <button type="submit">Create request</button>
    </form>
  );
}
